/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'display_life': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M884.025 1023.07a41.853 41.853 0 01-23.251-4.65L512 837.057 163.226 1018.42a54.409 54.409 0 01-46.503 0 55.339 55.339 0 01-23.252-41.853V93.007A93.006 93.006 0 01186.478 0h651.044a93.006 93.006 0 0193.007 93.006v883.56a55.339 55.339 0 01-23.252 41.854 34.877 34.877 0 01-23.252 4.65zM512 739.4a41.853 41.853 0 0123.252 4.65l302.27 158.112V93.006H186.478v809.156l302.27-158.111A41.853 41.853 0 01512 739.4z"/><path pid="1" _fill="#333" d="M512 604.541a43.713 43.713 0 01-46.503-46.503V279.02a46.503 46.503 0 0193.006 0v279.02A50.223 50.223 0 01512 604.54z"/><path pid="2" _fill="#333" d="M651.51 465.032H372.49a43.713 43.713 0 01-46.503-46.503 43.713 43.713 0 0146.503-46.504h279.02a43.713 43.713 0 0146.503 46.504 46.503 46.503 0 01-46.503 46.503z"/>'
  }
})
